// Real-time video filters (applied live in the studio and re-applied at playback).
// Each maps to a CSS filter string so the effect is genuinely rendered on the <video>.
export const VIDEO_FILTERS = [
  { key: "", label: "Aucun", css: "none" },
  { key: "beaute", label: "Beauté", css: "brightness(1.08) contrast(1.03) saturate(1.14)" },
  { key: "eclat", label: "Éclat", css: "saturate(1.55) contrast(1.12)" },
  { key: "nb", label: "N&B", css: "grayscale(1) contrast(1.06)" },
  { key: "vintage", label: "Vintage", css: "sepia(0.55) contrast(1.1) saturate(1.2) brightness(1.02)" },
  { key: "froid", label: "Froid", css: "hue-rotate(-18deg) saturate(1.25) brightness(1.03)" },
  { key: "chaud", label: "Chaud", css: "sepia(0.28) saturate(1.35) hue-rotate(8deg)" },
  { key: "drama", label: "Dramatique", css: "contrast(1.38) brightness(0.94) saturate(1.12)" },
  { key: "flou", label: "Rêve", css: "blur(0.6px) brightness(1.06) saturate(1.2)" },
];

export const filterCss = (key) => {
  const f = VIDEO_FILTERS.find((x) => x.key === (key || ""));
  return f ? f.css : "none";
};
